export enum OrchestrationRuntimeStatus {
  Running = 'Running',
  Completed = 'Completed',
  ContinuedAsNew = 'ContinuedAsNew',
  Failed = 'Failed',
  Canceled = 'Canceled',
  Terminated = 'Terminated',
  Pending = 'Pending',
  Unknown = 'Unknown'
}
